import { inEditor, inMgnl, inAppMobile, getUrlContext } from '@/helpers/AppHelpers';

// TODO: Corriger erreurs lint
// eslint-disable-next-line import/prefer-default-export,import/no-mutable-exports,no-var
export var mixinEnvironnement = {
  computed: {
    mixinEnvironnement_isDeveloppement() {
      return process.env.NODE_ENV == 'development';
    },
    mixinEnvironnement_isRouting() {
      return process.env.VUE_APP_IS_ROUTING === 'true';
    },
    mixinEnvironnement_inEditor() {
      return inEditor;
    },
    mixinEnvironnement_inMgnl() {
      return inMgnl;
    },
    mixinEnvironnement_inAppMobile() {
      return inAppMobile();
    },
    mixinEnvironnement_isNavigateurSupporte() {
      const navigateur = navigator.userAgent.toLowerCase();
      // rv:11 pour détecter IE11 et msie pour les versions antérieures (mots-clés propres aux versions d'IE)
      return navigateur.indexOf('rv:11') == -1 && navigateur.indexOf('msie') == -1;
    },
    mixinEnvironnement_damPath() {
      return getUrlContext(process.env.VUE_APP_BASE_DAM);
    },
  },
};
